import { GetFixedPosition } from '../../modules/GetFixedPosition';

// TODO (01-17-2023): This file should be modularized
var target = null;
self.canvasPanZoomOn = function (canvas, drawFunction, options, global) {
  canvas.panZoomOptions = options || {};
  canvas.panZoomOptions.transformOverlay = canvas.panZoomOptions.transformOverlay || function () {};
  canvas.canvasPanZoomOffset = { x: 0, y: 0 };
  canvasInit(canvas, drawFunction);
  var listenerTarget = canvas;
  if (global) {
    target = canvas;
    listenerTarget = document;
    listenerTarget.addEventListener('click', canvasClickListener);
  }
  listenerTarget.addEventListener('mousedown', canvasMouseDown);
  listenerTarget.addEventListener('mousemove', canvasMouseMove);
  listenerTarget.addEventListener('mouseup', canvasMouseUp);
  listenerTarget.addEventListener('mouseout', canvasMouseUp);
  listenerTarget.addEventListener('touchstart', canvasTouchStart, { passive: true });
  listenerTarget.addEventListener('touchmove', canvasTouchMove);
  listenerTarget.addEventListener('touchend', canvasTouchEnd);
  listenerTarget.addEventListener('mousewheel', canvasWheel);
  listenerTarget.addEventListener('gesturechange', canvasPinch);
};

self.canvasPanZoomOff = function (canvas) {
  var listenerTarget = canvas;
  if (target) {
    listenerTarget = document;
    target = null;
    listenerTarget.removeEventListener('click', canvasClickListener);
  }
  listenerTarget.removeEventListener('mousedown', canvasMouseDown);
  listenerTarget.removeEventListener('mousemove', canvasMouseMove);
  listenerTarget.removeEventListener('mouseup', canvasMouseUp);
  listenerTarget.removeEventListener('mouseout', canvasMouseUp);
  listenerTarget.removeEventListener('touchstart', canvasTouchStart);
  listenerTarget.removeEventListener('touchmove', canvasTouchMove);
  listenerTarget.removeEventListener('touchend', canvasTouchEnd);
  listenerTarget.removeEventListener('mousewheel', canvasWheel);
  listenerTarget.removeEventListener('gesturechange', canvasPinch);
  if (typeof canvas.drawFunction != 'undefined') {
    canvas.drawFunction();
  }
};

self.canvasInit = function (canvas, drawFunction) {
  if (!canvas.ctx) {
    canvas.ctx = Make2DContextQueryable(canvas.getContext('2d'));
  }
  if (typeof canvas.scale === 'undefined') {
    canvas.scale = 1;
  }

  canvas.drawFunction = drawFunction;
  canvas.scaleOnPoint = scaleOnPoint;
  canvas.rotateValue = {
    x: 0,
    y: 0
  };
  canvas.mouseWasDragged = false;
  canvas.mouseIsPressed = false;
  canvas.wasPinched = false;
  // canvas.transformProperty = getPrefixedProperty(canvas, 'transform');
  // canvas.transitionProperty = getPrefixedProperty(canvas, 'transition');
  // cssSetPerspective(canvas, 2000);
};
self.getCanvas = function (srcElement) {
  if (target) {
    return target;
  } else {
    return srcElement;
  }
};
self.canvasClickListener = function (e) {
  var canvas = getCanvas(this);
  canvas.mouseWasDragged = false;
};
self.canvasMouseDown = function (e) {
  var canvas = getCanvas(this);
  oneTouchStart(e, canvas, true);
};

self.canvasMouseMove = function (e) {
  if (e.webkitMovementX != 0 || e.webkitMovementY != 0) {
    var canvas = getCanvas(this);
    if (canvas.otherActionTaken) {
      canvas.otherActionTaken = false;
    } else {
      oneTouchMove(e, canvas, true);
      if (canvas.mouseIsPressed) {
        if (canvas.mouseOutWindow) {
          canvas.mouseOutWindow = false;
        } else {
          canvas.mouseWasDragged = true;
        }
      }
    }
  }
};

self.canvasMouseUp = function (e) {
  var canvas = getCanvas(this);
  if (e.type != 'mouseout' || (target != null && e.toElement == null && e.relatedTarget == null)) {
    oneTouchEnd(e, canvas);
    canvas.oneTouch = false;
    if (typeof canvas.touchedMoveDistance != 'undefined') {
      if (Math.abs(canvas.touchedMoveDistance.x) < 10 && Math.abs(canvas.touchedMoveDistance.y) < 10) {
        canvas.mouseWasDragged = false;
      }
      canvas.touchedMoveDistance = undefined;
    }
  }
  if (e.type == 'mouseout') {
    canvas.mouseOutWindow = true;
    oneTouchEnd(e, canvas);
    canvas.oneTouch = false;
    canvas.mouseWasDragged = false;
    canvas.touchedMoveDistance = undefined;
  }
};

self.canvasTouchStart = function (e) {
  var canvas = getCanvas(this);
  canvas.changePhoto = false;
  if (e.targetTouches.length == 1) {
    oneTouchStart(e, canvas, false);
  } else if (e.targetTouches.length == 2) {
    canvas.oneTouch = false;
    var offsetCoords = canvas.relMouseCoords(e, 0);
    var x1 = offsetCoords.x;
    var y1 = offsetCoords.y;
    var offsetCoords = canvas.relMouseCoords(e, 1);
    var x2 = offsetCoords.x;
    var y2 = offsetCoords.y;
    var pinchDistance = Math.pow(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2), 0.5);
    var X = (x1 + x2) / 2;
    var Y = (y1 + y2) / 2;
    canvas.pinch = {
      distance: pinchDistance,
      centerX: X,
      centerY: Y
    };
    canvas.pinchLoc = {
      x1: x1,
      y1: y1,
      x2: x2,
      y2: y2
    };
  }
};

self.canvasTouchMove = function (e) {
  var canvas = getCanvas(this);
  if (e.targetTouches.length == 1) {
    if (canvas.wasPinched) {
      canvas.wasPinched = false;
      canvas.touchedMoveDistance = undefined;
      oneTouchStart(e, canvas, false);
      if (e.preventDefault) e.preventDefault();
      e.returnValue = false;
      // }
    } else {
      oneTouchMove(e, canvas, false);
      if (e.preventDefault) e.preventDefault();
      e.returnValue = false;
    }
  } else if (e.targetTouches.length == 2) {
    canvas.wasPinched = true;
    var offsetCoords = canvas.relMouseCoords(e, 0);
    var x1 = offsetCoords.x;
    var y1 = offsetCoords.y;
    var offsetCoords = canvas.relMouseCoords(e, 1);
    var x2 = offsetCoords.x;
    var y2 = offsetCoords.y;
    var pinchDistance = Math.pow(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2), 0.5);
    var X = (x1 + x2) / 2;
    var Y = (y1 + y2) / 2;
    var ctxCoords = canvas.ctx.canvasToContext({
      x: X,
      y: Y
    });
    var reDraw = false;
    if (canvas.pinch.distance != pinchDistance) {
      if (canvas.id != 'mapCanvas') {
        let thisScale = pinchDistance / canvas.pinch.distance;
        let newScale = thisScale * canvas.scale;
        if (canvas.panZoomOptions.maxScale && newScale > canvas.panZoomOptions.maxScale) {
          newScale = canvas.panZoomOptions.maxScale;
          thisScale = newScale / canvas.scale;
        }
        canvas.scale = newScale;
        var newWidth = thisScale * canvas.width;
        var deltaWidth = newWidth - canvas.width;
        var newHeight = thisScale * canvas.height;
        var deltaHeight = newHeight - canvas.height;
        var translateX = ctxCoords.x / canvas.width;
        var translateY = ctxCoords.y / canvas.height;
        clearCanvas(canvas);
        canvas.ctx.translate(-deltaWidth * translateX, -deltaHeight * translateY);
        canvas.ctx.scale(thisScale, thisScale);
        canvas.panZoomOptions.transformOverlay();
      } else {
        canvas.scale = pinchDistance / canvas.pinch.distance;
      }
      reDraw = true;
    }
    if (canvas.pinch.centerX != X || canvas.pinch.centerY != Y) {
      if (canvas.scale >= 1 || canvas.id == 'mapCanvas') {
        smartPan(canvas, (X - canvas.pinch.centerX) / canvas.scale, (Y - canvas.pinch.centerY) / canvas.scale);
        if (canvas.id == 'mapCanvas') {
          canvas.scale = pinchDistance / canvas.pinch.distance;
        }
      } else {
        clearCanvas(canvas);
        //                removeGlow(this, 'all');
        canvas.ctx.translate((X - canvas.pinch.centerX) / canvas.scale, (Y - canvas.pinch.centerY) / canvas.scale);
        canvas.panZoomOptions.transformOverlay();
      }

      reDraw = true;
    }
    canvas.pinch = {
      distance: pinchDistance,
      centerX: X,
      centerY: Y
    };
    if (reDraw) {
      canvas.drawFunction();
    }
  }
};

self.canvasTouchEnd = function (e) {
  var canvas = getCanvas(this);
  if (e.touches.length == 0) {
    var reDraw = false;
    if (canvas.scale < 1) {
      var at = canvas.ctx.currentTransform();
      var trAr = TransformArithmetic;
      var inverse = trAr.inverse(at);
      canvas.ctx.transform(inverse.a, inverse.b, inverse.c, inverse.d, inverse.e, inverse.f);
      canvas.panZoomOptions.transformOverlay();
      canvas.scale = 1;
      reDraw = true;
    }
    oneTouchEnd(e, canvas);
    if (reDraw) {
      canvas.drawFunction();
    }
  }
  clearTimeout(canvas.pressTimer);
  if (canvas.oneTouch) {
    if (typeof e.targetTouches[0] != 'undefined') {
      if (canvas.panZoomOptions.click && typeof canvas.panZoomOptions.click === 'function') {
        canvas.panZoomOptions.click(canvas);
      }
    } else {
      canvas.mouseWasDragged = false;
    }
    canvas.oneTouch = false;
    if (typeof canvas.touchedMoveDistance != 'undefined') {
      if (Math.abs(canvas.touchedMoveDistance.x) < 10 && Math.abs(canvas.touchedMoveDistance.y) < 10) {
        canvas.mouseWasDragged = false;
      }
      canvas.touchedMoveDistance = undefined;
    }
  }
  canvas.changePhoto = false;
};

self.oneTouchStart = function (e, canvas, isMouse) {
  canvas.oneTouch = true;
  if (isMouse) {
    var mouseX = e.pageX;
    var mouseY = e.pageY;
    var relCoords = canvas.relMouseCoords(e);
  } else {
    var mouseX = e.targetTouches[0].pageX;
    var mouseY = e.targetTouches[0].pageY;
    var relCoords = canvas.relMouseCoords(e, 0);
  }
  canvas.mousePressedLoc = {
    x: mouseX,
    y: mouseY
  };
  canvas.mouseIsPressed = true;
  if (canvas.panZoomOptions.touchstart && typeof canvas.panZoomOptions.touchstart === 'function') {
    canvas.panZoomOptions.touchstart(canvas, relCoords);
  }
};

self.oneTouchMove = function (e, canvas, isMouse) {
  clearTimeout(canvas.pressTimer);
  if (canvas.mouseIsPressed) {
    if (isMouse) {
      var mouseX = e.pageX;
      var mouseY = e.pageY;
    } else {
      var mouseX = e.targetTouches[0].pageX;
      var mouseY = e.targetTouches[0].pageY;
    }
    var deltaX = mouseX - canvas.mousePressedLoc.x;
    var deltaY = mouseY - canvas.mousePressedLoc.y;

    if (typeof canvas.touchedMoveDistance === 'undefined') {
      canvas.touchedMoveDistance = {
        x: deltaX,
        y: deltaY
      };
    } else {
      canvas.touchedMoveDistance.x += deltaX;
      canvas.touchedMoveDistance.y += deltaY;
    }
    canvas.mousePressedLoc.x += deltaX;
    canvas.mousePressedLoc.y += deltaY;
    if (typeof canvas.selectedMarker != 'undefined') {
      if (canvas.selectedMarker.selectedSide == 'y') {
        canvas.selectedMarker.x += deltaX / (canvas.scale * canvas.originalScale);
        canvas.selectedMarker.y += deltaY / (canvas.scale * canvas.originalScale);
      } else if (canvas.selectedMarker.selectedSide == 'y2') {
        canvas.selectedMarker.x += deltaX / canvas.scale;
        canvas.selectedMarker.y2 += deltaY / canvas.scale;
      }
      if (canvas.touchedMoveDistance.x > 10) {
        var split = canvas.selectedMarker.color.split(',');
        var r = parseFloat(split[0].split('(')[1]);
        var g = parseFloat(split[1]);
        var b = parseFloat(split[2]);
        var opacity = parseFloat(split[3]);
        opacity = 0.8 - 0.02 * (canvas.touchedMoveDistance.x - 10);
        canvas.selectedMarker.dragX = true;
        canvas.selectedMarker.color = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity + ')';
      }
    } else {
      smartPan(canvas, deltaX / canvas.scale, deltaY / canvas.scale);
      if (canvas.id == 'mapCanvas') {
        canvas.scale = 1;
      }
    }

    canvas.drawFunction();
  }
};

self.oneTouchEnd = function (e, canvas) {
  if (canvas.panZoomOptions.touchend && typeof canvas.panZoomOptions.touchend === 'function') {
    canvas.panZoomOptions.touchend(canvas);
  }
  canvas.mouseIsPressed = false;
  var reDraw = false;
  canvas.drawFunction();
};

self.smartPan = function (canvas, thisXtranslate, thisYtranslate) {
  var xTranslate = canvas.ctx.currentTransform().e;
  var yTranslate = canvas.ctx.currentTransform().f;
  var cssTranslateX = 0;
  var setYTransform = -1;
  var setXTransform = -1;
  clearCanvas(canvas);
  if (canvas.className == 'poleCanvas') {
    //if (canvas.id != 'mapCanvas') {
    //If translate is off Left edge- move the pole photos, or glow
    if (xTranslate + thisXtranslate >= 0) {
      cssTranslateX += thisXtranslate * canvas.scale;
      //            thisXtranslate = -xTranslate;
      setXTransform = 0;
      if (canvas.className !== 'poleCanvas') {
        addGlow(canvas, 'left', canvas.pictureX, canvas.pictureY, canvas.pictureX, canvas.pictureY + canvas.pictureHeight);
      }
    }
    //If translate is off Right edge- move the pole photos, or glow
    else if (xTranslate + thisXtranslate <= canvas.pictureWidth * (1 - canvas.scale)) {
      cssTranslateX += thisXtranslate * canvas.scale;
      setXTransform = canvas.pictureWidth * (1 - canvas.scale);
      //            thisXtranslate = canvas.pictureWidth * (1 - canvas.scale) - xTranslate;
      if (canvas.className !== 'poleCanvas') {
        addGlow(
          canvas,
          'right',
          canvas.pictureX + canvas.pictureWidth,
          canvas.pictureY,
          canvas.pictureX + canvas.pictureWidth,
          canvas.pictureY + canvas.pictureHeight
        );
      }
    }
    //If Pole photos are moved, move them back before translating in picture
    else if (getCssTranslateX(canvas) !== 0) {
      if (Math.abs(thisXtranslate * canvas.scale) < Math.abs(getCssTranslateX(canvas))) {
        cssTranslateX += thisXtranslate * canvas.scale;
        thisXtranslate = 0;
      } else {
        cssTranslateX = -getCssTranslateX(canvas);
        thisXtranslate = (thisXtranslate * canvas.scale + getCssTranslateX(canvas)) / canvas.scale;
      }
    }
    //If Pole photo is axis-rotated, rotate back before translating in picture
    //TODO - looks broken??
    else if (getCssRotateY(canvas) !== 0) {
      if (Math.abs(thisXtranslate * canvas.scale) < Math.abs(getCssTranslateX(canvas))) {
        cssTranslateX += thisXtranslate * canvas.scale;
        thisXtranslate = 0;
      } else {
        cssTranslateX = -getCssTranslateX(canvas);
        thisXtranslate = (thisXtranslate * canvas.scale + getCssTranslateX(canvas)) / canvas.scale;
      }
    }

    //If translate is off Top edge - glow
    //        if (canvas.pictureHeight != canvas.height) {
    //            if (canvas.pictureHeight * canvas.scale < canvas.height) {
    //            if (thisYtranslate > 0) {
    //                addGlow(canvas, 'top', canvas.pictureX, canvas.pictureY, canvas.pictureX + canvas.pictureWidth, canvas.pictureY);
    //            }
    //            else {
    //                addGlow(canvas, 'bottom', canvas.pictureX, canvas.pictureY + canvas.pictureHeight, canvas.pictureX + canvas.pictureWidth, canvas.pictureY + canvas.pictureHeight);
    //            }
    //            thisYtranslate = 0;
    //
    //        }
    //        else {
    //        }
    //        }

    if (yTranslate + thisYtranslate >= 0) {
      addGlow(canvas, 'top', canvas.pictureX, canvas.pictureY, canvas.pictureX + canvas.pictureWidth, canvas.pictureY);
      setYTransform = 0;
    }
    //If translate is off Bottom edge - glow
    else if (yTranslate + thisYtranslate <= canvas.pictureHeight * (1 - canvas.scale)) {
      addGlow(
        canvas,
        'bottom',
        canvas.pictureX,
        canvas.pictureY + canvas.pictureHeight,
        canvas.pictureX + canvas.pictureWidth,
        canvas.pictureY + canvas.pictureHeight
      );
      setYTransform = canvas.pictureHeight * (1 - canvas.scale);
    }

    if (canvas.className == 'poleCanvas') {
      var loadingDistance = canvas.width / 4 + 1;
      for (var i = 0; i < 3; i++) {
        setTransition(poleCanvasList[i], canvas.transformProperty.prefixed, 'none');
      }
      if (canvas.whiteSpace) {
        if (thisXtranslate != 0) {
          cssTranslateX = thisXtranslate * canvas.scale;
        }
        thisXtranslate = 0;
        thisYtranslate = 0;
      }

      //If first pole, Rotate
      if (currentIndex === 0 && cssTranslateX > 0 && getCssTranslateX(canvas) >= 0) {
        cssTranslateTo(poleCanvasList[0], -(canvas.width + MARGIN_BETWEEN_POLES), 0);
        cssTranslateTo(poleCanvasList[1], 0, 0);
        cssTranslateTo(poleCanvasList[2], canvas.width + MARGIN_BETWEEN_POLES, 0);
        if (Math.abs(getCssRotateY(canvas) + cssTranslateX) < 25) {
          cssRotateY(canvas, cssTranslateX);
        } else {
          cssRotateYTo(canvas, 25);
          addGlow(canvas, 'left');
          removeGlow(canvas, 'top');
          removeGlow(canvas, 'bottom');
        }
      }
      //If last pole, Rotate
      else if (currentIndex == poleList.length - 1 && cssTranslateX < 0 && getCssTranslateX(canvas) <= 0) {
        if (Math.abs(getCssRotateY(canvas) + cssTranslateX) < 25) {
          cssRotateY(canvas, cssTranslateX);
        } else {
          cssRotateYTo(canvas, -25);
          addGlow(canvas, 'right');
          removeGlow(canvas, 'top');
          removeGlow(canvas, 'bottom');
        }
      }
      //Else Translate
      //TODO - seems broken - if its not first or last pole, there shouldnt be any rotateY right?
      else {
        var w = poleCanvasList[1].width + MARGIN_BETWEEN_POLES;
        var rotateY = getCssRotateY(canvas);
        var currentTranslateX = getCssTranslateX(canvas);
        if (rotateY != 0) {
          if (rotateY > 0 && rotateY + cssTranslateX < 0) {
            cssRotateYTo(canvas, 0);
            if (!poleCanvasList[2].completelyLoaded && cssTranslateX + rotateY + currentTranslateX < -loadingDistance) {
              cssTranslateTo(poleCanvasList[0], -w - loadingDistance, 0);
              cssTranslateTo(poleCanvasList[1], -loadingDistance, 0);
              cssTranslateTo(poleCanvasList[2], w - loadingDistance, 0);
            } else {
              for (var i = 0; i < 3; i++) {
                cssTranslate(poleCanvasList[i], cssTranslateX + rotateY, 0);
              }
            }
          } else if (rotateY < 0 && rotateY + cssTranslateX > 0) {
            cssRotateYTo(canvas, 0);
            if (!poleCanvasList[0].completelyLoaded && cssTranslateX + rotateY + currentTranslateX > loadingDistance) {
              cssTranslateTo(poleCanvasList[0], -w + loadingDistance, 0);
              cssTranslateTo(poleCanvasList[1], loadingDistance, 0);
              cssTranslateTo(poleCanvasList[2], w + loadingDistance, 0);
            } else {
              for (var i = 0; i < 3; i++) {
                cssTranslate(poleCanvasList[i], cssTranslateX + rotateY, 0);
              }
            }
          } else {
            cssRotateY(canvas, cssTranslateX);
          }
        } else {
          if (!poleCanvasList[2].completelyLoaded && cssTranslateX + currentTranslateX < -loadingDistance) {
            cssTranslateTo(poleCanvasList[0], -w - loadingDistance, 0);
            cssTranslateTo(poleCanvasList[1], -loadingDistance, 0);
            cssTranslateTo(poleCanvasList[2], w - loadingDistance, 0);
          } else if (!poleCanvasList[0].completelyLoaded && cssTranslateX + currentTranslateX > loadingDistance) {
            cssTranslateTo(poleCanvasList[0], -w + loadingDistance, 0);
            cssTranslateTo(poleCanvasList[1], loadingDistance, 0);
            cssTranslateTo(poleCanvasList[2], w + loadingDistance, 0);
          } else {
            for (var i = 0; i < 3; i++) {
              cssTranslate(poleCanvasList[i], cssTranslateX, 0);
            }
          }
        }
      }
      //Remove glow if moving between poles
      if (Math.abs(getCssTranslateX(canvas)) > canvas.width / 6) {
        removeGlow(canvas, 'top');
        removeGlow(canvas, 'bottom');
      }
    }
    //Set transform, or adjust transform
    if (setXTransform != -1 && setYTransform != -1) {
      canvas.ctx.setTransform(canvas.scale, 0, 0, canvas.scale, setXTransform, setYTransform);
    } else if (setXTransform != -1) {
      canvas.ctx.setTransform(canvas.scale, 0, 0, canvas.scale, setXTransform, yTranslate + thisYtranslate);
    } else if (setYTransform != -1) {
      canvas.ctx.setTransform(canvas.scale, 0, 0, canvas.scale, xTranslate + thisXtranslate, setYTransform);
    } else {
      canvas.ctx.translate(thisXtranslate, thisYtranslate);
    }
    canvas.panZoomOptions.transformOverlay();
  } else if (canvas.id == 'mapCanvas') {
    canvas.translateX = thisXtranslate;
    canvas.translateY = thisYtranslate;
  } else {
    canvas.ctx.translate(thisXtranslate, thisYtranslate);
    canvas.panZoomOptions.transformOverlay();
  }
};

self.canvasPinch = function (e) {
  if (event.preventDefault) event.preventDefault();
  event.returnValue = false;
};

self.canvasWheel = function (event) {
  var canvas = getCanvas(this);
  var delta = 0;
  var offsetCoords = canvas.relMouseCoords(event);
  var mouseX = offsetCoords.x;
  var mouseY = offsetCoords.y;
  if (!event) /* For IE. */ event = window.event;
  if (event.wheelDelta) {
    /* IE/Opera. */
    delta = (event.wheelDelta / 120) * canvas.scrollSensitivity;
  } else if (event.detail) {
    /** Mozilla case. */
    delta = -event.detail / 3;
  }
  if (delta) {
    if (canvas.id != 'mapCanvas') {
      let thisScale = 1 + delta / 10;
      let newScale = thisScale * canvas.scale;
      if (canvas.panZoomOptions.maxScale && newScale > canvas.panZoomOptions.maxScale) {
        newScale = canvas.panZoomOptions.maxScale;
        thisScale = newScale / canvas.scale;
      }
      canvas.scale = newScale;
      if (canvas.scale < 1) {
        canvas.scale = 1;
        canvas.ctx.setTransform(1, 0, 0, 1, 0, 0);
        canvas.panZoomOptions.transformOverlay();
      } else {
        var ctxCoords = canvas.ctx.canvasToContext({
          x: mouseX,
          y: mouseY
        });
        var newWidth = thisScale * canvas.width;
        var deltaWidth = newWidth - canvas.width;
        var newHeight = thisScale * canvas.height;
        var deltaHeight = newHeight - canvas.height;
        var translateX = ctxCoords.x / canvas.width;
        var translateY = ctxCoords.y / canvas.height;
        clearCanvas(canvas);
        canvas.ctx.translate(-deltaWidth * translateX, -deltaHeight * translateY);
        canvas.ctx.scale(thisScale, thisScale);
        canvas.panZoomOptions.transformOverlay();
      }
    } else {
      canvas.scale = 1 + delta / 10;
    }
    canvas.drawFunction();
  }
  if (event.preventDefault) event.preventDefault();
  event.returnValue = false;
};

self.scaleOnPoint = function (scale, x, y) {
  this.scale = scale * this.scale;
  if (this.scale < 1) {
    this.scale = this.scale / scale;
  } else {
    var newWidth = scale * this.width;
    var deltaWidth = newWidth - this.width;
    var newHeight = scale * this.height;
    var deltaHeight = newHeight - this.height;
    var translateX = x / this.width;
    var translateY = y / this.height;
    clearCanvas(this);
    this.ctx.translate(-deltaWidth * translateX, -deltaHeight * translateY);
    this.ctx.scale(scale, scale);
    canvas.panZoomOptions.transformOverlay();
    this.drawFunction();
  }
};

self.relMouseCoords = function (event, targetTouchIndex) {
  let canvasX = 0;
  let canvasY = 0;

  let offset = GetFixedPosition(this);
  let boundingClientRect = offset.elem === window ? { x: 0, y: 0 } : offset.elem.getBoundingClientRect();

  if (typeof targetTouchIndex != 'undefined') {
    canvasX = event.targetTouches[targetTouchIndex].clientX - offset.x - boundingClientRect.x;
    canvasY = event.targetTouches[targetTouchIndex].clientY - offset.y - boundingClientRect.y;
  } else {
    canvasX = event.clientX - offset.x - boundingClientRect.x;
    canvasY = event.clientY - offset.y - boundingClientRect.y;
  }
  // Manual way to handle offset from cssTransforms or other items.
  canvasX += getCanvas(this).canvasPanZoomOffset.x;
  canvasY += getCanvas(this).canvasPanZoomOffset.y;
  return {
    x: canvasX,
    y: canvasY
  };
};

self.clearCanvas = function (canvas) {
  canvas.ctx.save();
  canvas.ctx.setTransform(1, 0, 0, 1, 0, 0);
  canvas.ctx.clearRect(0, 0, canvas.width, canvas.height);
  canvas.ctx.restore();
};

if (typeof HTMLCanvasElement != 'undefined') {
  HTMLCanvasElement.prototype.relMouseCoords = relMouseCoords;
}
HTMLDivElement.prototype.relMouseCoords = relMouseCoords;

window.TransformArithmetic = {};
var ta = TransformArithmetic;
ta.project = function (p, t) {
  return {
    x: t.a * p.x + t.c * p.y + t.e,
    y: t.b * p.x + t.d * p.y + t.f
  };
};
ta.multiply = function (t2, t1) {
  return {
    a: t1.a * t2.a + t1.b * t2.c,
    c: t1.c * t2.a + t1.d * t2.c,
    b: t1.a * t2.b + t1.b * t2.d,
    d: t1.c * t2.b + t1.d * t2.d,
    e: t1.e * t2.a + t1.f * t2.c + t2.e,
    f: t1.e * t2.b + t1.f * t2.d + t2.f
  };
};
ta.translate = function (x, y) {
  return {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: x,
    f: y
  };
};
ta.rotate = function (theta) {
  return {
    a: Math.cos(theta),
    b: Math.sin(theta),
    c: -Math.sin(theta),
    d: Math.cos(theta),
    e: 0,
    f: 0
  };
};
ta.scale = function (x, y) {
  return {
    a: x,
    b: 0,
    c: 0,
    d: y,
    e: 0,
    f: 0
  };
};
ta.ident = function () {
  return {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
  };
};
ta.clone = function (t) {
  return {
    a: t.a,
    b: t.b,
    c: t.c,
    d: t.d,
    e: t.e,
    f: t.f
  };
};
ta.inverse = function (t) {
  var det = t.a * t.d - t.c * t.b;
  return {
    a: t.d / det,
    b: -t.b / det,
    c: -t.c / det,
    d: t.a / det,
    e: (t.c * t.f - t.e * t.d) / det,
    f: (t.e * t.b - t.a * t.f) / det
  };
};
ta.interp = function (t1, t2, i) {
  var t = {},
    a = ['a', 'b', 'c', 'd', 'e', 'f'];
  for (var j = 0, k; (k = a[j]); j++) t[k] = t1[k] + (t2[k] - t1[k]) * i;
  return t;
};

window.Make2DContextQueryable = function (ctx) {
  if (ctx.contextToCanvas) return;

  var transforms = [ta.ident()];
  function current() {
    return transforms[transforms.length - 1];
  }

  function set(t) {
    transforms[transforms.length - 1] = t;
  }

  function apply_to(t) {
    transforms[transforms.length - 1] = ta.multiply(current(), t);
  }

  function proxy_before(o, fn, f) {
    var oldf = o[fn];
    o[fn] = function () {
      f.apply(o, arguments);
      oldf.apply(o, arguments);
    };
  }

  proxy_before(ctx, 'save', function () {
    transforms.push(ta.clone(current()));
  });
  proxy_before(ctx, 'restore', function () {
    if (transforms.length > 1) transforms.pop();
    else transforms[0] = ident();
  });
  proxy_before(ctx, 'scale', function (x, y) {
    apply_to(ta.scale(x, y));
  });
  proxy_before(ctx, 'rotate', function (theta) {
    apply_to(ta.rotate(theta));
  });
  proxy_before(ctx, 'translate', function (x, y) {
    apply_to(ta.translate(x, y));
  });
  proxy_before(ctx, 'transform', function (a, b, c, d, e, f) {
    apply_to({
      a: a,
      b: b,
      c: c,
      d: d,
      e: e,
      f: f
    });
  });
  proxy_before(ctx, 'setTransform', function (a, b, c, d, e, f) {
    set({
      a: a,
      b: b,
      c: c,
      d: d,
      e: e,
      f: f
    });
  });

  ctx.contextToCanvas = function (p) {
    return ta.project(p, current());
  };
  ctx.canvasToContext = function (p) {
    return ta.project(p, ta.inverse(current()));
  };
  ctx.currentTransform = function () {
    return current();
  };
  return ctx;
};
